import React, { useEffect, useState } from 'react';
import { authFetch } from '../../Utilities/Api';
import './AdminImageDeletion.css';

const AdminImageDeletion = () => {
    const [images, setImages] = useState([]);

    const fetchImages = async () => {
        try {
            const res = await authFetch('/api/admin/images');
            setImages(res.data || []);
        } catch (err) {
            console.error('Failed to fetch images:', err);
        }
    };

    const deleteImage = async (id) => {
        if (!window.confirm('Are you sure you want to delete this image?')) return;

        try {
            await authFetch.delete(`/api/admin/images/${id}`);
            setImages(images.filter(img => img._id !== id));
        } catch (err) {
            console.error('Failed to delete image:', err);
        }
    };

    useEffect(() => {
        fetchImages();
    }, []);

    return (
        <div className="admin-image-deletion">
            <h2>🗑️ Image Deletion</h2>
            <ul>
                {images.map(image => (
                    <li key={image._id}>
                        <img src={image.url} alt={image.caption || 'Image'} width="100" />
                        <button onClick={() => deleteImage(image._id)}>Delete</button>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default AdminImageDeletion;
